import { render, staticRenderFns } from "./FooterQuickLinks.vue?vue&type=template&id=6f67cca7"
import script from "./FooterQuickLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterQuickLinks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FooterQuickLinks.vue?vue&type=style&index=0&id=6f67cca7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports